import React from 'react';
import { FloatingPanel } from '../ui';
import { NotificationItem } from '../../client/notificationsClient';
import NotificationRow from './NotificationRow';

/**
 * The dropdown behind the bell: the newest notifications, a quiet
 * "Mark all read", and an honest empty state. Presentational — the caller
 * (see `useNotifications`) owns fetching, mark-read and navigation.
 */
export interface NotificationPanelProps {
  items: NotificationItem[];
  unreadCount: number;
  onSelect: (notification: NotificationItem) => void;
  onMarkAllRead: () => void;
  className?: string;
}

export const NotificationPanel: React.FC<NotificationPanelProps> = ({
  items,
  unreadCount,
  onSelect,
  onMarkAllRead,
  className = '',
}) => (
  <FloatingPanel className={`w-[320px] overflow-hidden ${className}`}>
    <div className="flex items-center justify-between border-b border-line-divider px-s5 py-s4">
      <p className="text-row-title text-ink">Notifications</p>
      {unreadCount > 0 && (
        <button
          type="button"
          onClick={onMarkAllRead}
          className="text-meta font-medium text-action hover:text-action-hover"
        >
          Mark all read
        </button>
      )}
    </div>
    {items.length === 0 ? (
      <p className="px-s5 py-s6 text-body-sm text-ink-muted">
        No notifications yet — research results and supplier replies will land here.
      </p>
    ) : (
      <ul className="max-h-[380px] divide-y divide-line-divider overflow-y-auto">
        {items.map((notification) => (
          <NotificationRow key={notification.id} notification={notification} onSelect={onSelect} />
        ))}
      </ul>
    )}
  </FloatingPanel>
);

export default NotificationPanel;
